// Pricing Rule Applied: 
// Tutorials/Vol: $97 (₹8,051)
// Advanced/TM: $197 (₹16,351)
// DFY Masterclass/Workshop: $297 (₹24,651)
// Flagship/Playbook: $247 (₹20,501)

export const categories = [
  {
    id: 'ai-tools',
    title: 'Pillar 1: AI Tools, AI Business & Automation',
    description: 'Master the tools that replace a 10-person team and automate your growth.',
    totalValue: '₹4,85,000',
    courses: [
      { title: 'AI Consulting Playbook', price: 247 },
      { title: 'AI Consulting Playbook Vol 2', price: 247 },
      { title: 'AI Consulting DFY Masterclass', price: 297 },
      { title: 'Perplexity AI Tutorials', price: 97 },
      { title: 'Perplexity Advanced Tutorials', price: 197 },
      { title: 'AI Video (Pictory)', price: 97 },
      { title: 'AI Avatar (HeyGen)', price: 97 },
      { title: 'HeyGen DFY Workshop', price: 297 },
      { title: 'Claude AI Vol 1', price: 97 },
      { title: 'Claude AI Vol 2', price: 97 },
      { title: 'Claude DFY Masterclass', price: 297 },
      { title: 'Claude Advanced Tutorials', price: 197 },
      { title: 'ElevenLabs AI Voice', price: 97 },
      { title: 'ElevenLabs DFY', price: 297 },
      { title: 'ElevenLabs Tutorial Masterclass', price: 197 },
      { title: 'Microsoft AI Vol 1 & 2', price: 194 },
      { title: 'Microsoft AI DFY & Advanced', price: 494 },
      { title: 'Google AI Tools Series (Vol 2, 4, 5, 6)', price: 388 },
      { title: 'Google AI Tools Advanced', price: 197 },
      { title: 'Zapier AI Tutorials & DFY', price: 394 },
      { title: 'One AI Video Per Day (Vol 3 & 4)', price: 194 },
      { title: 'AI Website Playbook', price: 247 }
    ]
  },
  {
    id: 'marketing',
    title: 'Pillar 2: Digital Marketing & Traffic',
    description: 'Predictable traffic systems using both paid and organic engines.',
    totalValue: '₹3,20,000',
    courses: [
      { title: 'YouTube Ads System', price: 247 },
      { title: 'YouTube Ads DFY', price: 297 },
      { title: 'Blog Marketing Playbook', price: 247 },
      { title: 'Blog Marketing DFY', price: 297 },
      { title: 'Pinterest Marketing & DFY', price: 394 },
      { title: 'YouTube Marketing & DFY', price: 394 },
      { title: 'GetResponse Systems & DFY', price: 394 },
      { title: 'Email Marketing Playbook & DFY', price: 394 }
    ]
  },
  {
    id: 'funnels',
    title: 'Pillar 3: Funnels, Automation & Systems',
    description: 'The "Engine Room" of your business. Build high-converting sales machines.',
    totalValue: '₹5,40,000',
    courses: [
      { title: 'Sales Funnel Playbook', price: 247 },
      { title: 'Sales Funnel DFY', price: 297 },
      { title: 'Clickfunnels Mastery', price: 197 },
      { title: 'Systeme.io Full Series (Vol 1-9)', price: 873 },
      { title: 'Systeme.io DFY Series', price: 297 },
      { title: 'GoHighLevel Platform Mastery', price: 247 },
      { title: 'GHL Subaccounts & DFY', price: 494 },
      { title: 'Zoom Playbook & DFY Masterclass', price: 494 },
      { title: 'Thrivecart Checkout & DFY', price: 394 }
    ]
  },
  {
    id: 'content-media',
    title: 'Pillar 4: Content Creation & Media',
    description: 'Produce world-class visual and audio assets without being a pro.',
    totalValue: '₹2,80,000',
    courses: [
      { title: 'Canva Ecosystem (Vol 1, AI, Masterclass)', price: 391 },
      { title: 'Canva DFY Masterclass', price: 297 },
      { title: 'CapCut Video Editing (Vol 1, DFY, TM)', price: 591 },
      { title: 'Audacity Audio Mastery & DFY', price: 394 },
      { title: 'Screencast University & DFY', price: 394 },
      { title: 'PowerPoint Playbook & DFY', price: 394 }
    ]
  },
  {
    id: 'business-models',
    title: 'Pillar 5: Business Models & Income Streams',
    description: 'The strategy layer. How to actually package and sell your OS.',
    totalValue: '₹6,15,000',
    courses: [
      { title: 'Affiliate Marketing & DFY', price: 394 },
      { title: 'JV Management & DFY', price: 394 },
      { title: 'Shopify Ecommerce & DFY', price: 394 },
      { title: 'Membership Builder & DFY', price: 394 },
      { title: 'Free Membership Playbook & DFY', price: 394 },
      { title: 'Online Course Playbook & DFY', price: 544 },
      { title: 'Virtual Summit Playbook & DFY', price: 544 },
      { title: 'Skool Community Mastery & DFY', price: 544 }
    ]
  },
  {
    id: 'authority',
    title: 'Pillar 6: Personal Branding & Authority',
    description: 'Move from "just another person" to the undisputed leader in your niche.',
    totalValue: '₹3,90,000',
    courses: [
      { title: 'Authorpreneur Masterclass & DFY', price: 494 },
      { title: 'Book Publishing Advanced', price: 197 },
      { title: 'Offline Social Media & Video Marketing', price: 194 },
      { title: 'Authentic Leadership & DFY', price: 394 },
      { title: 'Journaling Playbook & DFY', price: 344 }
    ]
  },
  {
    id: 'beginner-foundation',
    title: 'Pillar 7: Beginner Foundation System',
    description: 'The ground-zero training for those starting from absolute scratch.',
    totalValue: '₹4,50,000',
    courses: [
      { title: 'New Marketer Series (Vol 1-12)', price: 1164 },
      { title: 'New Marketer DFY Volumes', price: 297 },
      { title: 'New Marketer 52-Week Live Series', price: 997 },
      { title: 'New Marketer Workshop & Advanced', price: 394 }
    ]
  },
  {
    id: 'mindset',
    title: 'Pillar 8: Mindset, Productivity & Life Skills',
    description: 'The mental operating system required to handle 8-figure growth.',
    totalValue: '₹1,20,000',
    courses: [
      { title: 'Conquer Procrastination & DFY', price: 394 },
      { title: 'Procrastination Advanced', price: 197 },
      { title: 'Survival Skills for Entrepreneurs', price: 97 }
    ]
  }
];

export const totalProgramValue = "₹37,50,000+";
export const totalCoursesCount = 178;